module.exports = require('./helpers/bundle-url').getBundleURL('dsYo6') + "logo.c51670a8.svg";